import React, { useMemo, useState, useEffect } from "react";
import { Tables } from "../../../../../components/Elements/Tables/Tables";
import { ReactComponent as EditIcon } from "../../../../../assets/svgs/edit-icon.svg";
import { ReactComponent as AddDepartmentIcon } from "../../../../../assets/svgs/add-department.svg";
import { ReactComponent as DeleteIcon } from "../../../../../assets/svgs/delete.svg";
import { SearchBar } from "../../../../../components/Elements/Search/SearchBar";
import { ReactComponent as FilterIcon } from "../../../../../assets/svgs/filters-icon.svg";
import EditLocation from "./EditLocation";
import AddLocation from "./AddLocation";
import FilterLocationDeparment from "../FilterLocationDeparment";
import { Button } from "antd";
import { fetchAllLocations } from "../../../../../redux/OrganizationSetup/organizationSetupSlice";
import { setSelectedLocationId } from "../../../../../redux/OrganizationSetup/organizationSetupSlice";
import { useDispatch, useSelector } from "react-redux";
import PopupCard from "../../../../Auth/PopupCard";
import { deleteLocation } from "../../../../../redux/OrganizationSetup/organizationSetupSlice";
import AssignDepartment from "./AssignDepartment";

const Location = ({ onOpenImportLocation }) => {
  const [addLocations, setAddLocations] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [editLocations, setEditLocations] = useState(false);
  const [addDepartment, setAddDepartment] = useState(false);
  const [selectedLocationForDept, setSelectedLocationForDept] = useState(null);
  const [openFilter, setOpenFilter] = useState(false);

  const [deleteConfirmation, setDeleteConfirmation] = useState({
    visible: false,
    locationId: null,
    locaationName: "",
  });

  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState(null);

  const [successPopup, setSuccessPopup] = useState({
    visible: false,
    title: "",
    message: "",
  });

  const { orgMode } = useSelector((state) => state.orgSetup);
  const user = useSelector((state) => state.auth.user);

  const effectiveMode = orgMode || user?.orgStructureMode;
  const isDepartmentFirst = effectiveMode === "department-first";
  const dispatch = useDispatch();

  //----API CALL---
  useEffect(() => {
    dispatch(fetchAllLocations());
  }, [dispatch]);

  //---REDUX STATE---
  const { locationList } = useSelector((state) => state.orgSetup);

  //---Handle Page Change---
  const pageSize = 5;
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const filteredLocationList = useMemo(() => {
    if (!locationList) return [];

    return locationList.filter((location) => {
      // 1. Apply Search Filter (matches name, type, or city)
      const searchMatch =
        !searchQuery ||
        location.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        location.location_type
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        location.city?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (location.isActive ? "active" : "inactive").includes(
          searchQuery.toLowerCase(),
        );

      // 2. Apply Status Filter — treat 'All' as no-filter
      const statusMatch =
        !statusFilter ||
        statusFilter === "All" ||
        (statusFilter === "active" ? location.isActive : !location.isActive);

      return searchMatch && statusMatch;
    });
  }, [locationList, searchQuery, statusFilter]);

  //-----Table Data---
  const tableData = useMemo(() => {
    return (
      filteredLocationList?.map((location, index) => ({
        key: location._id,
        serial: <div className="text-center">{index + 1}</div>,
        locationName: <div className="text-center">{location.name}</div>,
        locationType: (
          <div className="text-center">{location.location_type || "-"}</div>
        ),
        locationCity: <div className="text-center">{location.city || "-"}</div>,

        ...(isDepartmentFirst
          ? {}
          : {
              departments: (
                <div className="text-center">
                  {location.linkedDepartmentCount || 0}
                </div>
              ),
            }),

        status: (
          <div className="text-center">
            {location.isActive ? "Active" : "Inactive"}
          </div>
        ),

        action: (
          <div className="flex gap-4 justify-center" title="">
            {!isDepartmentFirst && (
              <AddDepartmentIcon
                onClick={() => {
                  setSelectedLocationForDept(location._id);
                  setAddDepartment(true);
                }}
              />
            )}

            <EditIcon
              onClick={() => {
                dispatch(setSelectedLocationId(location._id));
                setEditLocations(true);
              }}
            />

            <DeleteIcon
              onClick={() =>
                setDeleteConfirmation({
                  visible: true,
                  locationId: location._id,
                  locationName: location.name,
                })
              }
            />
          </div>
        ),
      })) || []
    );
  }, [filteredLocationList, dispatch, isDepartmentFirst]);

  // Table Headers
  const headers = useMemo(() => {
    const baseHeaders = [
      { label: "Sr. No.", key: "serial" },
      { label: "Location Name", key: "locationName" },
      { label: "Type", key: "locationType" },
      { label: "City", key: "locationCity" },
    ];

    if (!isDepartmentFirst) {
      baseHeaders.push({ label: "Departments", key: "departments" });
    }

    baseHeaders.push(
      { label: "Status", key: "status" },
      { label: "Action", key: "action" },
    );

    return baseHeaders;
  }, [isDepartmentFirst]);

  return (
    <div>
      <h1 className="text-[18px] font-bold text-[#06513D] mb-4">
        Add Location
      </h1>

      <div className="bg-white border border-[#3BA2B959] rounded-xl p-4 shadow-md">
        <div className="flex flex-col lg:flex-row lg:justify-between gap-4 px-4 sm:px-6 mb-4">
          <div className="flex flex-col sm:flex-row flex-wrap gap-4 w-full lg:w-auto">
            <div className="w-full sm:w-auto flex-1">
              <SearchBar
                width="100%"
                onSearch={(value) => setSearchQuery(value)}
                placeholder="Search by name, type, city or status..."
              />
            </div>
            <Button
              style={{ background: "#E6EDEB", border: "solid 1px #06513D" }}
              className="text-[12px] text-[#06513D] font-light px-4 py-5 hover:!bg-[#F8F8F8] hover:!text-[#06513D]"
              onClick={() => setOpenFilter(true)}
            >
              <FilterIcon className="mr-1" />
              FILTER
            </Button>
          </div>

          <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full lg:w-auto">
            <Button
              style={{ background: "#E6EDEB", border: "solid 1px #06513D" }}
              className="text-[12px] text-[#06513D] font-light px-4 py-5 hover:!bg-[#F8F8F8] hover:!text-[#06513D]"
              onClick={onOpenImportLocation}
            >
              Import Location
            </Button>
            <button
              className="bg-[#06513D] rounded-md hover:bg-[#06513DCC] text-[12px] text-white font-light px-4 py-3 w-full sm:w-auto"
              onClick={() => setAddLocations(true)}
            >
              + Add Location
            </button>
          </div>
        </div>
        <Tables
          data={tableData}
          headers={headers}
          total={tableData.length}
          onChange={handlePageChange}
          pageSize={pageSize}
          current={currentPage}
        />
      </div>
      {/* Delete Confirmation */}
      {deleteConfirmation.visible && (
        <div className="fixed inset-0 bg-black/30 z-[9999] flex items-center justify-center">
          <PopupCard
            type="warning"
            title="Confirm Delete"
            message={`Are you sure you want to delete ${deleteConfirmation.locationName}?`}
            showActions={true}
            confirmText="Yes, Delete"
            cancelText="Cancel"
            onCancel={() =>
              setDeleteConfirmation({
                visible: false,
                locationId: null,
                locationName: "",
              })
            }
            onConfirm={() => {
              dispatch(deleteLocation(deleteConfirmation.locationId))
                .unwrap()
                .then((res) => {
                  setDeleteConfirmation({
                    visible: false,
                    locationId: null,
                    locationName: "",
                  });

                  setSuccessPopup({
                    visible: true,
                    title: "Deleted",
                    message: res?.message || "Location deleted successfully!",
                  });

                  setTimeout(() => {
                    setSuccessPopup({
                      visible: false,
                      title: "",
                      message: "",
                    });
                  }, 3000);
                })
                .catch((err) => {
                  setDeleteConfirmation({
                    visible: false,
                    locationId: null,
                    locationName: "",
                  });
                  setSuccessPopup({
                    visible: true,
                    title: "Error",
                    message:
                      typeof err === "string"
                        ? err
                        : err?.message || "Failed to delete location.",
                  });
                  setTimeout(() => {
                    setSuccessPopup({
                      visible: false,
                      title: "",
                      message: "",
                    });
                  }, 3000);
                });
            }}
          />
        </div>
      )}
      {/* Success Popup */}
      {successPopup.visible && (
        <div className="fixed inset-0 bg-black/30 z-[9999] flex items-center justify-center">
          <PopupCard
            type="success"
            title={successPopup.title}
            message={successPopup.message}
          />
        </div>
      )}
      {/* ----Add new location---- */}
      {addLocations && (
        <AddLocation
          onOpen={addLocations}
          onClose={() => setAddLocations(false)}
        />
      )}
      {/* ----Edit Location------ */}
      {editLocations && (
        <EditLocation
          onOpen={editLocations}
          onClose={() => setEditLocations(false)}
        />
      )}
      {/* --------Open Filter-------- */}
      {openFilter && (
        <FilterLocationDeparment
          onOpen={openFilter}
          onClose={() => setOpenFilter(false)}
          currentStatus={statusFilter}
          onApply={(status) => {
            setStatusFilter(status);
            setCurrentPage(1); // Reset to first page on filter application
          }}
        />
      )}
      {/* --------Open addDepartment-------- */}
      {addDepartment && (
        <AssignDepartment
          onOpen={addDepartment}
          locationId={selectedLocationForDept}
          onClose={() => {
            setAddDepartment(false);
            setSelectedLocationForDept(null);
          }}
        />
      )}
    </div>
  );
};

export default Location;
